// extracted by mini-css-extract-plugin
module.exports = {"moduleItem":"moduleItem--1kNG6","white":"white--2CLwm","grey":"grey--3bo9w","title":"title--fpEkk"};